<template>
  <div class="flex flex-wrap mb-2 relative">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div class="flex items-center space-x-8 stage_tree_outer">
        <div v-for="(stage, stageIndex) in stageTreeListData" :key="stageIndex" class="flex items-center">
          <div class="border border-black rounded-md py-2 px-4 w-56">
            <div v-for="(item, itemIndex) in stage" :key="itemIndex" class="last:mb-0 border rounded-md py-1 px-2 my-1 cursor-pointer" :class="[activeStageIndex == stageIndex && activeItemIndex == itemIndex ? 'action_item' : {'text-blue-500': item.isGoAhead, 'text-gray-800': !item.isGoAhead}]" @click="switchPhase(stageIndex, itemIndex)">
              <span>
                {{ methodList[item.method] }} ({{ platformList[item.platform] }})
                <i v-if="item.isGoAhead === true" v-tooltip.top="'為前進條件'" class="pi pi-arrow-right text-sm"></i>
              </span>
            </div>
          </div>

          <div v-if="stageIndex < stageTreeListData.length - 1" class="ml-4">
            <div class="w-8 h-8 border-t-4 border-r-4 border-black transform rotate-45"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
  </div>
</template>
<script>
import lightImg from "@/assets/light.png";

export default {
  name: "StageTreeBlock",
  components: {},
  props: {
    editPage: {
      type: Boolean
    },
    treeUpdateStatus: {
      type: String
    },
    stageTreeList: {
      type: Array,
    },
    activeStageTreeNodeIndex: {
      type: Number,
    },
    activeStageTreeItemIndex: {
      type: Number,
    },
    viewDatalist: {
      type: String
    },
    customRulesDataList: {
      type: Object
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      lightImg: lightImg,
      campaignName: '',
      methodList: {
        META_TEST: '測試素材',
        META_ASC: 'ASC',
        META_KW: '精準興趣',
        META_LA: '類似受眾',
        META_RT: '再行銷',
      },
      platformList: {
        facebook: 'Facebook',
        tiktok: 'Tiktok'
      },
      activeStageIndex: 0,
      activeItemIndex: 0
    };
  },
  watch:{
    'lang':function(v){
    //  console.log('CampaignName watch this.lang');
    //  console.log(this.lang);
    },
    'viewDatalist':function(v){
    //  console.log('viewDatalist：'+v);
      this.campaignName = v
    },
    campaignName (value){
    //  console.log('value：'+value);
      // this.viewDatalist = value;
      this.$emit('childCampaignName', value);
      // console.log('viewDatalistData：'+this.viewDatalist);
    },
    treeUpdateStatus(value){
    //  console.log('treeUpdateStatus', value);
      let _tmpdata = value.split('_');

    //  console.log('b activeStageIndex', this.activeStageIndex);
    //  console.log('b activeItemIndex', this.activeItemIndex);

      if(_tmpdata[0] === 'true'){
        this.activeStageIndex = 0;
        this.activeItemIndex = 0;
      }

    //  console.log('a activeStageIndex', this.activeStageIndex);
    //  console.log('a activeItemIndex', this.activeItemIndex);
    },
    activeStageTreeNodeIndex(value){
    //  console.log('activeStageTreeNodeIndex', value);
      if(typeof value !== 'undefined'){
      //  console.log('change');
        this.activeStageIndex = value;
      }
    //  console.log('this.activeStageIndex', this.activeStageIndex);
    },
    activeStageTreeItemIndex(value){
    //  console.log('activeStageTreeItemIndex', value);
      if(typeof value !== 'undefined'){
      //  console.log('change');
        this.activeItemIndex = value;
      }
    //  console.log('this.activeItemIndex', this.activeItemIndex);
    },
  },
  methods: {
    openTeaching(){
      this.$emit('childOpenTeaching', 111);
    },
    methodName(value){
      switch(value){
        case 'META_TEST':
          return '測試素材（Facebook）';
          break;
        case 'META_KW':
          return '精準興趣（Facebook）';
          break;
        case 'META_LA':
          return '類似受眾（Facebook）';
          break;
        case 'META_RT':
          return '再行銷（Facebook）';
          break;
        case 'META_ASC':
          return 'ASC（Facebook）';
          break;
        case 'TIKTOK_KW':
          return '精準興趣（Tiktok）';
          break;
        case 'TIKTOK_RT':
          return '再行銷（Tiktok）';
          break;
      }
    },
    itemStage(action, index){
    //  console.log('itemStage');
    //  console.log(action +':'+ index);
      if(action == index){
        return {backgroundColor:'#1D619F', color:'#fff'};
      } else {
        return {backgroundColor:'#F2F2F2', color:'#8C8C8C'};
      }
    },
    switchPhase(stageIndex, itemIndex){
      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      todayForm = yearForm + monthForm + dateForm + timeForm;

      // console.log('b stageblock customRulesDataList');
      // console.log(this.customRulesDataList);

      this.activeStageIndex = stageIndex;
      this.activeItemIndex = itemIndex;

      this.$emit('childSwitchPhase', stageIndex+'_'+itemIndex);

      // console.log('a stageblock customRulesDataList');
      // console.log(this.customRulesDataList);
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    stageTreeListData: {
      get: function () {
        return this.stageTreeList
      },
      set: function (value) {
        this.$emit('update:stageTreeList', value)
      },
    },
    customRulesDataListData: {
      get: function () {
        return this.customRulesDataList
      },
      set: function (value) {
        this.$emit('update:customRulesDataListData', value)
      },
    },
  }
};
</script>
<style>
  .action_item{
    background-color:#1D619F;
    color:#fff;
  }
  .stage_tree_outer {
    max-width: 930px; /* 設定外部容器的最大寬度 */
    overflow-x: auto; /* 溢出時產生橫向滾動條 */
    padding: 5px;
  }
  /* 自定義滾動條樣式 */
  .stage_tree_outer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .stage_tree_outer::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .stage_tree_outer::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 6px;
  }

  .stage_tree_outer::-webkit-scrollbar-thumb:hover {
    background: #D9D9D9;
  }
</style>